export default {
  commercial: 'Commercial',
  condo: 'Condo',
  land: 'Land',
  multi_unit: 'Multi Unit',
  single_family: 'Single Family',
};




// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/real_estate/resources/propertyTypes.js